import http from '../../HttpConfig'
import {APIS_ENDPOINTS} from '../../SERVICE-CONSTANTS'
import {ISupportVideoPayload} from '../../SERVICE-INTERFACES'

const supportVideo_endpoints = APIS_ENDPOINTS.supportVideo

export const request_create = async ({Title, VideoUrl}: ISupportVideoPayload) => {
  const formData = new FormData()
  formData.append('Title', Title)
  formData.append('VideoUrl', VideoUrl)

  return http.post(supportVideo_endpoints.create, formData)
}
export const request_edit = async ({Title, VideoUrl, Id}: ISupportVideoPayload) => {
  const formData = new FormData()
  formData.append('Title', Title)
  formData.append('VideoUrl', VideoUrl)
  formData.append('Id', Id.toString())

  return http.put(supportVideo_endpoints.edit, formData)
}

export const request_getAll = async ({
  search,
  CurrentPage,
  PageSize,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
}) => {
  return http.get(
    supportVideo_endpoints.getlist +
      `?CurrentPage=${CurrentPage}&PageSize=${PageSize}${search ? `&search=${search}` : ''}`
  )
}

export const request_delete = async (id: number) => {
  return http.delete(supportVideo_endpoints.delete + `?Id=${id}`)
}

export const request_unactive = async (id: number) => {
  return http.delete(supportVideo_endpoints.unactive + `?Id=${id}`)
}

export const request_active = async (id: number) => {
  return http.put(supportVideo_endpoints.active + `?Id=${id}`)
}

